<template>
  <div class="container">

    <div>
      <el-button type="primary" @click="handleAdd" size="small">添加标签组</el-button>
    </div>

    <el-table
      :data="data"
    >

      <el-table-column
        prop="id"
        label="ID"
        sortable
      />

      <el-table-column
        prop="name"
        label="标签类目"
        sortable
      />

      <el-table-column
        prop="time"
        label="创建时间"
        sortable
      />

      <el-table-column
        label="操作"
      >
        <template scope="scope">   
          <el-button-group>
            <el-button type="primary" size="mini" icon="el-icon-folder-opened" @click="handleGoToItem(scope.row)" >标签条目</el-button>
            <!-- <el-button type="warning" size="mini" icon="el-icon-edit" title="编辑" @click="handleEdit(scope.row)" >编辑</el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" title="删除" @click="handleDelete(scope.row)" >删除</el-button> -->
          </el-button-group>
        </template>
      </el-table-column>

    </el-table>

    <pager
      ref="pager"
      api="tag_series_list"
      :filter="filter"
      :sort="sort"
      model="cs"
      :defaultPageSize="50"
      @data-changed="onDataChanged"
    />

    <el-dialog 
      title="添加"
      :visible.sync="showEditForm"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleEditFormDialogClose"
    >

      <el-form ref="editForm" :model="editForm" :rules="editRules" label-position="right">
        <el-form-item prop="name" label="标签组名称:" label-width="150px">
          <el-input v-model="editForm.name" style="width:50%" />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditForm = false">取 消</el-button>
        <el-button type="primary" @click="handleSave"> 确 定 </el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Pager from '../ui/Pager.vue';
import request from '../../api/request';

  const initForm = {
    name: null
  },
  initRules = {
    name: [
      {
        required: true,
        message: "名称不能为空"
      }
    ],
  }

  export default {
  components: { Pager },
    name: "UserTagManage",
    data() {
      return {
        data: null,
        filter: {},
        sort: [],
        editRules: { ...initRules },
        editForm: { ...initForm },
        showEditForm: false,
        submiting: false
      };
    },
    created() {
    },
    methods: {
      onDataChanged(data) {
        this.data = data
      },
      handleAdd() {
        this.showEditForm = true
      },
      handleEdit(row) {
        this.editForm = { ...row } 
      },
      handleSave() {
        this.$refs.editForm.validate(async valid => {
          if (valid && !this.submiting) {
            this.submiting = true
              request.cs
                .post('tag_series_create', this.editForm)
                .then(() => {
                  this.showEditForm = false
                  this.$message.success('添加成功')
                  this.$refs.pager.loadData()
                  setTimeout(() => {
                    this.submiting = false
                  }, 500)
                })
                .catch(() => {
                  this.$message.error('添加失败')
                  setTimeout(() => {
                    this.submiting = false
                  }, 500)
                })
          }
        })
      },
      handleDelete(row) {
        console.log(row)
      },
      handleGoToItem(row) {
        this.$router.push(`/tools/userTag/${row.id}/${row.name}`)
      },
      handleEditFormDialogClose() {
        this.editForm = { ...initForm } 
        this.$refs.editForm.clearValidate()
      }
    }
  };
</script>
